import map from 'lodash/map'


export const uploadFiles = async (files, client) => {
  return await Promise.all(
    map(
      files,
      async file => {
        let formData = new FormData()
        formData.append('file', file)

        const _file = await client.mutate(
          [
            'files',
          ],
          false,
          {
            body: formData,
            headers: {
              'Content-Type': undefined,
            },
          }
        )

        return _file.data
      }
    )
  )
}
